import { render, staticRenderFns } from "./ErrorModal.vue?vue&type=template&id=e7da78da&lang=pug"
import script from "./ErrorModal.vue?vue&type=script&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&lang=ts"
import style0 from "./ErrorModal.vue?vue&type=style&index=0&id=e7da78da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports